module.exports = __webpack_public_path__ + "img/logo.7179e379.png";